import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { first, switchMap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Tag } from '../interface/tag';
import { DataService } from './data.service';
import { DisableOrActive, EnumDisableOrActive } from '../interface/disableOrActive';


@Injectable({
    providedIn: 'root'
  })
  export class TagService {
    private _isFromMatrix = true;

    tag: Tag[] = [];
    BASE_URL = `${environment.mkgoURL}/api/v1/tag`;

    constructor(
      private dataService: DataService,
      private http: HttpClient
    ) { }

    async create(tag: Tag): Promise<Tag> {
      const header = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
      const resp = await this.http.post(this.BASE_URL, tag, header).pipe(first()).toPromise();
      return resp as Tag;
    }

    async getAll(): Promise<Tag[]> {
      const header = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
      const resp = await firstValueFrom(this.http.get<{tags: Tag[]}>(this.BASE_URL, header));
      const tags = resp.tags.filter(tag => tag.available == EnumDisableOrActive.ACTIVE);
      return tags;
    }

    public update(tag: Tag) {
      const body = {description: tag.description}
      return this.dataService.httpOptions(this._isFromMatrix).pipe(
        switchMap(options => this.http.put(`${this.BASE_URL}/${tag._id}`, body, options)),
        first()
      );
    }

    async delete(tag: Tag) {
      const header = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
      const resp = await this.http.delete(`${this.BASE_URL}/${tag._id}`, header).pipe(first()).toPromise();
      return resp as Tag;
    }

    async getInactives(): Promise<Tag[]> {
      const header = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
      const resp = await firstValueFrom(this.http.get<{tags: Tag[]}>(`${this.BASE_URL}/inactives`, header));
      return resp.tags;
    }

    public async inactiveOrActive(id: string, action: DisableOrActive) {
      const url = `${this.BASE_URL}/${id}/${action}`;
      const header = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
      return await firstValueFrom(this.http.put(url, {}, header));
    }
  }
